
export function storeToken(name, tok)
{
    try
    {
      localStorage.setItem(name, tok);
    }
    catch(e)
    {
      console.log(e.message);
    }
}

export function retrieveToken(name)
{
    var ud;
    try
    {
      ud = localStorage.getItem(name);
    }
    catch(e)
    {
      console.log(e.message);
    }
    return ud;
}